const generateTransparentGrid = () => {
	const light = [253, 254, 253]; // 亮色 FEFEFE
	const dark = [227, 229, 231]; // 暗色 E3E5E8
	const opca = 255; // 透明度
	const back = [light, dark, dark, light].flatMap((i) => [i[0], i[1], i[2], opca]);
	const imageData = new ImageData(new Uint8ClampedArray(back), 2, 2);
	const canvas = document.createElement('canvas');
	const context = canvas.getContext('2d')!;
	canvas.width = imageData.width;
	canvas.height = imageData.height;
	context.putImageData(imageData, 0, 0);
	return canvas.toDataURL();
};

export const TransparentBackgroud = `url(${generateTransparentGrid()})`;
